import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import "./index.less";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function back() {
  window.history.go(-1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "m-btn-back",
    onClick: back
  }))
}
}

})